import React from 'react';
import { Badge } from '@/components/ui/badge';
import { X } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import type { FilterChip } from '../types';

interface FilterChipsProps {
  filterChips: FilterChip[];
}

export const FilterChips: React.FC<FilterChipsProps> = ({ filterChips }) => {
  const getChipColor = (color: string = 'neutral') => {
    const colors = {
      moss: 'bg-moss-primary/10 text-moss-primary border-moss-primary/30 hover:bg-moss-primary/20',
      brick: 'bg-brick-primary/10 text-brick-primary border-brick-primary/30 hover:bg-brick-primary/20',
      yellow: 'bg-yellow-500/10 text-yellow-700 border-yellow-300 hover:bg-yellow-100',
      neutral: 'bg-muted text-muted-foreground border-border hover:bg-muted/80'
    };
    return colors[color as keyof typeof colors] || colors.neutral;
  };

  return (
    <>
      {filterChips.map((chip) => (
        <Badge
          key={chip.key}
          variant="outline"
          className={cn(
            "cursor-pointer transition-colors gap-1",
            getChipColor(chip.color)
          )}
          onClick={chip.onRemove}
          title={`Remove ${chip.category ? `${chip.category}: ${chip.label}` : chip.label}`}
        >
          <span className="truncate">
            {chip.category ? `${chip.category}: ${chip.label}` : chip.label}
          </span>
          <X className="h-3 w-3" />
        </Badge>
      ))}
    </>
  );
};
